import { PartyType } from '@parties/src/types';
import { IconName } from '@wegroup/design-system';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface AnvaFlowsInsurancesResponse {
  items: AnvaFlowsInsuranceTag[];
}
export interface AnvaFlowsInsuranceTag {
  id: number;
  name: string;
  insurance_ids: number[];
  icon_key: IconName;
}

export const getAnvaFlowsInsuranceTags = async (
  partyType: PartyType | undefined,
) => {
  const { data, isError } = await wgApi.get<AnvaFlowsInsurancesResponse>(
    `/v1/api/anvaflows/supported-tags`,
    {
      query: { party_type: partyType },
    },
  );
  if (isError) throw new Error();
  return data;
};

export const getUseAnvaFlowsInsuranceTags = (
  partyType: PartyType | undefined,
) => ['flow-config', 'anva', 'insurance-tags', partyType];

export const useAnvaFlowsInsuranceTags = (partyType: PartyType | undefined) => {
  return useQuery(
    getUseAnvaFlowsInsuranceTags(partyType),
    () => getAnvaFlowsInsuranceTags(partyType),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};
